import { render, staticRenderFns, recyclableRender, components } from "./u-form-item.vue?vue&type=template&id=e1c67d6a&scoped=true&"
var renderjs
import script from "./u-form-item.vue?vue&type=script&lang=js&"
export * from "./u-form-item.vue?vue&type=script&lang=js&"
import style0 from "./u-form-item.vue?vue&type=style&index=0&id=e1c67d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c67d6a",
  null,
  false,
  components,
  renderjs
)

export default component.exports